$(document).on('turbo:load turbo:render interests:added', () => {
    let $interests: JQuery = $('#interests > form');
    $interests.find(".interest-text-for-label").on('input change', (event) => {
        let streetInput: any = $(event.target).val();
        let $form: JQuery = $(event.target).closest('form');
        let $subtitle: JQuery = $form.find('span.interest-subtitle');

        if ($subtitle.text() == '') {
            $subtitle.text('Expand to View');
        } else {
            $subtitle.text(streetInput);
        }
    });

    $interests.find('.expandable-form').on('show.bs.collapse', (event) => {
        let $form = $(event.target).closest('form');
        let $subtitle: JQuery = $form.find('span.interest-subtitle');
        if ($subtitle.text() == "Expand to View") {
            $subtitle.text('');
        }
    });

    $interests.find('.expandable-form').on('hide.bs.collapse', (event) => {
        let $form = $(event.target).closest('form');
        let streetInput: any = $form.find('.interest-text-for-label').val();
        let $subtitle: JQuery = $form.find('span.interest-subtitle');
        if ($subtitle.text() == "") {
            $subtitle.text('Expand to View');
        }
    });
});